import { ArticleSections, ITextSection, LeftMenuItem } from 'types/articles';

export const getLeftMenuItems = (articleSections: ArticleSections[]): LeftMenuItem[] =>
  articleSections.map((data) => ({
    id: data.title,
    label: data.title,
    submenu: ((data as ITextSection)?.submenu || []).map((item) => item.title),
  }));
